
const GetExImMonthlyReportReducer = (state = { type: 'LOADING_EXIM_MONTHLY_REPORT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_EXIM_MONTHLY_REPORT_ACTION':
            return action
        case 'RESET_EXIM_MONTHLY_REPORT_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetExImCountryReportReducer = (state = { type: 'LOADING_EXIM_COUNTRY_REPORT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_EXIM_COUNTRY_REPORT_ACTION':
            return action
        case 'RESET_EXIM_COUNTRY_REPORT_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetExImDropdownReducer = (state = { type: 'LOADING_EXIM_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_EXIM_DROPDOWN_ACTION':
            return action
        case 'RESET_EXIM_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetExImSecondaryDropdownReducer = (state = { type: 'LOADING_EXIM_COUNTRY_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_EXIM_COUNTRY_DROPDOWN_ACTION':
            return action
        case 'RESET_EXIM_COUNTRY_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
// const GetImarcDetailReducer = (state = { type: 'LOADING_IMARC_DETAIL_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_IMARC_DETAIL_ACTION':
//             return action
//         case 'RESET_IMARC_DETAIL_ACTION':
//             return {
//                 ...state,
//                 type: action.payload
//             };  
//         default:
//             return state
//     }
// }
export {
    GetExImDropdownReducer,
    GetExImSecondaryDropdownReducer,
    GetExImMonthlyReportReducer,
    GetExImCountryReportReducer
    // GetImarcDetailReducer
}